<template>
    <div class="push">
        <a-page-header
            style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
            :breadcrumb="{ props: { routes } }"
        />

        <div class="push-detail">
            <a-card>
                <div>
                    <div class="search">
                        <label for="">采购需求：</label>
                        <a-input placeholder="" v-model="keywords" style="width:300px;margin-right:20px"/>
                        <!-- <label for="">采购状态：</label>
                        <a-select default-value="1" style="width: 200px" >
                            <a-select-option value="1">
                                采购中
                            </a-select-option>
                            <a-select-option value="2">
                                已过期
                            </a-select-option>
                        </a-select> -->
                        <a-button @click="query" type="primary">查询</a-button>
                    </div>


                    <a-table
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    :data-source="data"
                    >
                        <span slot="action" slot-scope="text, record">
                            <a href="javascript:;" @click="getdetail($event)" :id="record.id"><a-icon type="file-search"/>查看</a>
                        </span>
                    </a-table>


                </div>
            </a-card>
        </div>

        <a-modal v-model="tipvisible" width="700px" :centered="true"  title="留言详情"  class="tipdeatil" >
            <a-row>
                <a-col :span="12">
                <a-row>
                    <a-col :span="6">
                    <label>商品名称：</label>
                    </a-col>
                    <a-col :span="18">
                    <a-input :value="detailinfo.name" :disabled='true'/>
                    </a-col>
                </a-row>
                </a-col>
                <a-col :span="12">
                <a-row>
                    <a-col :span="6">
                    <label>数量：</label>
                    </a-col>
                    <a-col :span="18">
                    <a-input :value="detailinfo.num" :disabled='true'/>
                    </a-col>
                </a-row>
                </a-col>
            </a-row>

            <a-row>
                <a-col :span="12">
                <a-row>
                    <a-col :span="6">
                    <label>单位：</label>
                    </a-col>
                    <a-col :span="18">
                    <a-input :value="detailinfo.unit" :disabled='true'/>
                    </a-col>
                </a-row>
                </a-col>
                <a-col :span="12">
                <a-row>
                    <a-col :span="6">
                    <label>品牌：</label>
                    </a-col>
                    <a-col :span="18">
                    <a-input :value="detailinfo.brand" :disabled='true'/>
                    </a-col>
                </a-row>
                </a-col>
            </a-row>

            <a-row>
                <a-col :span="12">
                    <a-row>
                        <a-col :span="6">
                        <label>截止时间：</label>
                        </a-col>
                        <a-col :span="18">
                        <a-input :value="detailinfo.end_time" :disabled='true'/>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>

            <a-row>
                <a-col :span="24">
                <a-row>
                    <a-col :span="3">
                    <label>留言内容：</label>
                    </a-col>
                    <a-col :span="21">
                    <a-textarea placeholder="" :value="detailinfo.remark" :rows="4" :disabled='true'/>
                    </a-col>
                </a-row>
                </a-col>
            </a-row>

            <a-row>
                <a-col :span="24">
                <a-row>
                    <a-col :span="3">
                    <label>图片：</label>
                    </a-col>
                    <a-col :span="21">
                        <ul class="imglist">
                            <li v-for="(img,index) in detailinfo.image" :key="index">
                                <img :src="img" alt="">
                            </li>
                        </ul>
                    </a-col>
                </a-row>
                </a-col>
            </a-row>

            <a-divider />

            <a-row>
                <a-col :span="12">
                <a-row>
                    <a-col :span="6">
                    <label>联系人：</label>
                    </a-col>
                    <a-col :span="18">
                    <a-input :value="detailinfo.contract" :disabled='true'/>
                    </a-col>
                </a-row>
                </a-col>
                <a-col :span="12">
                <a-row>
                    <a-col :span="6">
                    <label>手机号：</label>
                    </a-col>
                    <a-col :span="18">
                    <a-input :value="detailinfo.phone" :disabled='true'/>
                    </a-col>
                </a-row>
                </a-col>
            </a-row>

            <a-row>
                <a-col :span="12">
                <a-row>
                    <a-col :span="6">
                    <label>公司名称：</label>
                    </a-col>
                    <a-col :span="18">
                    <a-input :value="detailinfo.company" :disabled='true'/>
                    </a-col>
                </a-row>
                </a-col>
                <a-col :span="12">
                <a-row>
                    <a-col :span="6">
                    <label>收货城市：</label>
                    </a-col>
                    <a-col :span="18">
                    <a-input :value="detailinfo.address" :disabled='true'/>
                    </a-col>
                </a-row>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '采购需求',
    dataIndex: 'remark',
    key: 'remark',
  },
  {
    title: '发布时间',
    dataIndex: 'create_time',
    key: 'create_time',
  },
  {
    title: '报价截止时间',
    key: 'end_time',
    dataIndex: 'end_time',
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    filters: [
      { text: '采购中', value: '1' },
      { text: '已过期', value: '2' },
    ],
    filterMultiple: false,

  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
    data(){
        return{
            tipvisible:false,
            data:"",
            columns,
            pagination: {},
            loading: false,
            keywords:"",
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '推送商机'},
            ],
            detailinfo:""
        }
    },
    mounted(){
        // this.$axios.get('/api/getpurchaselist',{
        //     headers: {
        //         "appid": this.appSet.appid,
        //         "appkey": this.appSet.appkey,
        //         "token":localStorage.getItem('token'),
        //     }
        // }).then((res)=>{
        //     if(res.data.code==200){
        //         this.data=res.data.data.lists
        //     }
        // })
        this.fetch()
    },
    methods:{
        // 关键词查询
        query(){
            this.fetch()
            // this.$axios.get('/api/getpurchaselist',{
            //     headers: {
            //         "appid": this.appSet.appid,
            //         "appkey": this.appSet.appkey,
            //         "token":localStorage.getItem('token'),
            //     },
            //     params:{
            //         keywords:this.keywords
            //     }
            // }).then((res)=>{
            //     if(res.data.code==200){
            //         this.data=res.data.data.lists
            //     }
            // })
        },
        getdetail(event){
            var id=event.currentTarget.id
            this.tipvisible=true
            this.$axios.get('/api/getpurchasedetail',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.detailinfo=res.data.data
                }
            })
        },

        handleTableChange(pagination, filters, sorter) {
            console.log("filters="+JSON.stringify(filters));
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                limits: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },

            
        fetch(params = {}) {
            params=JSON.parse(JSON.stringify(params).replace(/status/g, 'isover'));
            console.log('params:', params);
            if(params.length>0){
                params.isover=params.isover[0]
            }
            this.loading = true;
            this.$axios.get('/api/getpurchaselist',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    limits: 10,
                    keywords:this.keywords,
                    ...params,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    this.data=res.data.data.lists
                    this.loading = false;
                    this.pagination = pagination;
                    // this.pagination = pagination;
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })

        },

    }
}
</script>




// WEBPACK FOOTER //
// src/components/push/index.vue